export * from './MoneyWalletAIcon';
export * from './MoneyWalletAIcon16Light';
export * from './MoneyWalletAIcon16Regular';
export * from './MoneyWalletAIcon16Solid';
export * from './MoneyWalletAIcon20Light';
export * from './MoneyWalletAIcon20Regular';
export * from './MoneyWalletAIcon20Solid';
export * from './MoneyWalletAIcon24Regular';
export * from './MoneyWalletAIcon24Solid';
export * from './MoneyWalletAIcon32Regular';
export * from './MoneyWalletAIcon64Regular';
